import { render, staticRenderFns } from "./xy3.vue?vue&type=template&id=1337be51&scoped=true&"
import script from "./xy3.vue?vue&type=script&lang=js&"
export * from "./xy3.vue?vue&type=script&lang=js&"
import style0 from "./xy3.vue?vue&type=style&index=0&id=1337be51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337be51",
  null
  
)

export default component.exports